import { PartialNullable } from "./types";
import { DraftAlbum, MultiTrackTableItem, RegionSettings, TrackReleaseSet } from "./api/useMusicApi";
import _ from "lodash";

export function truncate(str: string, n: number) {
  return str.length > n ? str.slice(0, n - 1) + "..." : str;
}

export function changeArrayPosition<T>(
  fromIndex: number,
  toIndex: number,
  array: Array<T>
): Array<T> {
  const copyArrayForImmutable = [...array];
  copyArrayForImmutable.splice(fromIndex, 1);
  copyArrayForImmutable.splice(toIndex, 0, array[fromIndex]);
  return copyArrayForImmutable;
}

export const makeDarkStyle = (classNames: string) => {
  const classNameAsArray = classNames.split(" ");
  return classNameAsArray.map((c) => "dark:" + c).join(" ");
};

export const getArtistsWithMoreThatOneUniqueUrl = (t: any, album: PartialNullable<DraftAlbum>, tracks: PartialNullable<MultiTrackTableItem | TrackReleaseSet>[]) => {
  const artistTitleUrlsMap = {};
  tracks.forEach(track => {
    track?.country_meta?.artists.main?.map(mainArtist => {
      if (mainArtist["ALL"]! in artistTitleUrlsMap) {
        // @ts-ignore
        artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [...artistTitleUrlsMap[mainArtist["ALL"]! ?? ""],
          {
            url: mainArtist["vk_url"],
            track: `${t("track")}: ${track.country_meta?.title[RegionSettings.ALL]}`
          }
        ];
      } else {
        // @ts-ignore
        artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [
          {
            url: mainArtist["vk_url"],
            track: `${t("track")}: ${track.country_meta?.title[RegionSettings.ALL]}`
          }
        ];
      }
    });

    track?.country_meta?.artists.featured?.map(mainArtist => {
      if (mainArtist["ALL"]! in artistTitleUrlsMap) {
        // @ts-ignore
        artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [...artistTitleUrlsMap[mainArtist["ALL"]! ?? ""],
          {
            url: mainArtist["vk_url"],
            track: `${t("track")}: ${track.country_meta?.title[RegionSettings.ALL]}`
          }
        ];
      } else {
        // @ts-ignore
        artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [
          {
            url: mainArtist["vk_url"],
            track: `${t("track")}: ${track.country_meta?.title[RegionSettings.ALL]}`
          }
        ];
      }
    });
  });

  album?.country_meta?.artists.main?.map(mainArtist => {
    if (mainArtist["ALL"]! in artistTitleUrlsMap) {
      // @ts-ignore
      artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [...artistTitleUrlsMap[mainArtist["ALL"]! ?? ""],
        {
          url: mainArtist["vk_url"],
          track: `${t("album")}: ${album.country_meta?.title[RegionSettings.ALL]}`
        }
      ];
    } else {
      // @ts-ignore
      artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [
        {
          url: mainArtist["vk_url"],
          track: `${t("album")}: ${album.country_meta?.title[RegionSettings.ALL]}`
        }
      ];
    }
  });

  album?.country_meta?.artists.featured?.map(mainArtist => {
    if (mainArtist["ALL"]! in artistTitleUrlsMap) {
      // @ts-ignore
      artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [...artistTitleUrlsMap[mainArtist["ALL"]! ?? ""],
        {
          url: mainArtist["vk_url"],
          track: `${t("album")}: ${album.country_meta?.title[RegionSettings.ALL]}`
        }
      ];
    } else {
      // @ts-ignore
      artistTitleUrlsMap[mainArtist["ALL"]! ?? ""] = [
        {
          url: mainArtist["vk_url"],
          track: `${t("album")}: ${album.country_meta?.title[RegionSettings.ALL]}`
        }
      ];
    }
  });

  return Object.entries(artistTitleUrlsMap).filter(([artistName, trackMetaData]) => {
    return _.uniq((trackMetaData as []).map((t: { url: string, track: string }) => t.url)).length > 1;
  });

};
